import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { SearchField, Select } from '@/shared/ui';
function pluralRows(count) {
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod10 === 1 && mod100 !== 11)
        return 'строка';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
        return 'строки';
    }
    return 'строк';
}
export function PriorityFilters({ filters, total, onChange, onReset, }) {
    const [draftQ, setDraftQ] = useState(filters.q);
    useEffect(() => {
        setDraftQ(filters.q);
    }, [filters.q]);
    useEffect(() => {
        if (draftQ.trim() === filters.q)
            return;
        const timer = window.setTimeout(() => {
            onChange({ ...filters, q: draftQ.trim() });
        }, 250);
        return () => window.clearTimeout(timer);
    }, [draftQ, filters, onChange]);
    const active = filters.q.length > 0 || filters.status !== 'all';
    return (_jsxs("div", { className: "flex flex-wrap items-center gap-2 rounded-[var(--unity-radius)] border border-border bg-[var(--unity-color-elevated)] px-3 py-2", children: [_jsxs("div", { className: "text-[length:var(--unity-work-compact-font-size,0.875rem)] italic text-muted-foreground", children: [_jsx("strong", { className: "not-italic text-foreground", children: total }), ' ', pluralRows(total)] }), _jsx(SearchField, { className: "min-w-[14rem] flex-1", value: draftQ, onValueChange: setDraftQ, placeholder: "\u0418\u043C\u044F \u0438\u043B\u0438 ID \u0430\u0433\u0435\u043D\u0442\u0430", "aria-label": "\u041F\u043E\u0438\u0441\u043A \u0432 \u043F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442\u043D\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435" }), _jsx(Select, { size: "compact", className: "min-w-[10rem]", value: filters.status, onValueChange: (value) => onChange({ ...filters, status: value }), options: [
                    { value: 'all', label: 'Все' },
                    { value: 'matched', label: 'Связаны' },
                    { value: 'review', label: 'На сверку' },
                ], "aria-label": "\u0421\u043E\u043F\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435" }), active ? (_jsx("button", { type: "button", className: "text-[11px] text-primary hover:underline", onClick: onReset, children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C" })) : null] }));
}
